import React, { Component } from 'react'
import { withRouter } from 'react-router-dom'
import { provideState, injectState, softUpdate } from 'freactal'
import app from '../../../feathers'
import MappingDialog from '../../components/MappingDialog'

const withState = provideState({
  initialState: (
    { match: { params: { taskIndex } } },
    { freactal: { state } },
  ) => {
    const { name } = state.unit.formativePracticalAssessment[taskIndex]
    return {
      updateTaskMappingError: null,
      taskName: name,
    }
  },
  effects: {
    updateTaskMapping: async (effects, { _id, taskIndex, mapping }) => {
      try {
        effects.setSaving(true)
        await app.service('units').patch(_id, {
          [`formativePracticalAssessment.${taskIndex}.mapping`]: mapping,
        })
        effects.setSaving(false)
      } catch (updateTaskMappingError) {
        return () => ({ updateTaskMappingError })
      }
    },
    setSaving: softUpdate((_, saving) => ({ saving })),
  },
})

class TaskMapping extends Component {
  state = {
    mapping: this.props.state.unit.formativePracticalAssessment[
      this.props.match.params.taskIndex
    ].mapping,
  }

  handleChangeMapping = mapping => this.setState({ mapping })
  saveMapping = async () => {
    const {
        match: { params: { taskIndex } },
        state: { unit: { _id } },
        effects: { updateTaskMapping },
        history,
      } = this.props,
      { mapping } = this.state
    await updateTaskMapping({
      _id,
      taskIndex,
      mapping,
    })
    history.goBack()
  }
  render() {
    const { state: { taskName, saving }, history } = this.props
    const { mapping } = this.state
    return (
      <MappingDialog
        title={`Mapping for Task ''${taskName}''`}
        goBack={history.goBack}
        mapping={mapping}
        onChangeMapping={this.handleChangeMapping}
        saveMapping={this.saveMapping}
        displaySpinner={saving}
        showAllMapping={true}
        showToggle={false}
      />
    )
  }
}

export default withRouter(withState(injectState(TaskMapping)))



// WEBPACK FOOTER //
// ./src/Units/ManageUnit/FormativePracticalAssessments/TaskMapping.js